export enum SingleSlotDetailsDataHook {
  SERVICE_NAME = 'service-name',
  PRICE_LINE = 'price-line',
  SELECTED_ADDONS = 'selected-addons',
  SELECTED_ADDON_ITEM = 'selected-addon-item',
  MORE_DETAILS = 'more-details',
  MORE_DETAILS_ACCORDION = 'more-details-accordion',
  MORE_DETAILS_BUTTON = 'more-details-button',
  LESS_DETAILS_BUTTON = 'less-details-button',
}
